import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicGroupsInstallment({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 120 80"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        opacity={0.2}
        d="M68.337 64.915c-1.303 7.406-19.059 18.955-35.404 9.354-7.602-4.466-5.92-8.554-10.851-15.604-2.94-4.201-7.691-7.966-8.048-13.163-.31-4.486 1.523-8.805 4.428-11.216 6.531-5.423 17.675-7.585 25.21 5.102 7.537 12.687 28.024 6.425 24.665 25.527zm40.007-12.646c-1.449 2.584-4.621 2.94-9.703 2.448-3.823-.37-7.308-.656-11.13-2.74-2.676-1.458-4.794-3.43-6.34-5.345-1.675-2.076-4.012-4.444-2.866-6.796 1.575-3.232 10.683-5.954 19.528-1.503 9.716 4.891 11.927 11.409 10.511 13.936z"
        fill="#62B9F7"
      />
      <g filter="url(#pic_groups_installment_svg__a)">
        <path
          d="M36 13a2 2 0 012-2h34.571L84 22.429V65a2 2 0 01-2 2H38a2 2 0 01-2-2V13z"
          fill="#fff"
        />
      </g>
      <path opacity={0.5} d="M72.572 11L84 22.429h-9.428a2 2 0 01-2-2V11z" fill="#A3CBE7" />
      <path
        d="M45 23.571h18m-18 6h18m-18 6h30m-30 6h30m-30 6h30M45 54h30"
        stroke="#E3E8E8"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 37.087l.234.714c.81 2.476 3.373 3.792 5.726 2.94 2.353-.853 3.603-3.55 2.793-6.027L32.52 34"
        fill="#F08519"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.866 6.768L24.188 4.8a4.154 4.154 0 00-7.856 2.705l.677 1.967"
        fill="#147EC9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.562 21.634c-1.846-5.36 1.004-11.203 6.364-13.05l3.883-1.336c5.36-1.846 11.203 1.004 13.049 6.364l2.062 5.99a4.53 4.53 0 002.297 2.596l1.846.9a4.528 4.528 0 012.297 2.596 4.283 4.283 0 01-2.655 5.444l-22.96 7.906a4.283 4.283 0 01-5.444-2.655 4.533 4.533 0 01.21-3.462l.9-1.846a4.525 4.525 0 00.21-3.462l-2.059-5.985z"
        fill="#147EC9"
      />
      <path
        d="M100.862 62.381c-1.91 6.343-8.604 9.935-14.965 8.022-6.357-1.91-9.965-8.602-8.06-14.947 1.907-6.339 8.608-9.932 14.965-8.022 6.36 1.912 9.969 8.605 8.06 14.947z"
        fill="#FB8F23"
      />
      <path
        d="M98.123 61.559c-1.454 4.832-6.557 7.572-11.403 6.116-4.844-1.46-7.596-6.559-6.142-11.39 1.456-4.836 6.56-7.576 11.403-6.117 4.846 1.456 7.594 6.553 6.142 11.391z"
        fill="#FFF6CC"
      />
      <path
        d="M88.768 64.385l-.434 1.553-1.422-.411.425-1.512c-1.386-.49-2.612-1.309-3.224-2.133l1.254-1.464c.567.719 1.484 1.389 2.479 1.782l.649-2.315c-1.47-.832-3.089-1.854-2.534-3.835.41-1.468 1.856-2.413 4.172-2.014l.432-1.539 1.422.411-.425 1.512c1.042.39 2.002.969 2.647 1.678l-1.187 1.5a6.211 6.211 0 00-1.969-1.352l-.658 2.356c1.478.815 3.063 1.832 2.515 3.785-.408 1.444-1.837 2.382-4.142 1.998zm.299-6.539l.55-1.968c-.802-.05-1.209.264-1.34.723-.131.483.216.872.79 1.245zm1.504 4.05c.138-.485-.203-.866-.754-1.254l-.534 1.915c.753.053 1.165-.218 1.288-.66z"
        fill="#FB8F23"
      />
      <defs>
        <filter
          id="pic_groups_installment_svg__a"
          x={28}
          y={5}
          width={64}
          height={72}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={4} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_719_15868" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_719_15868" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicGroupsInstallment.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicGroupsInstallment.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicGroupsInstallment svgRef={ref} {...props} />
));
export default ForwardRef;
